export const EMPTY_STATE_SCOPES = {
  DEFAULT: null,
  PAGE: 'page',
  COMPACT: 'compact',
};
